import React, { useEffect, useMemo } from 'react'

import Chat from '../Chat/Chat'
import Header from '../Header/Header'
import { styleByScreenSize } from './configs'
import { WebSocketsSharedConsumer } from '../../../integrations/WebSockets'

import classes from './styles.module.scss'
import '../../../app/App.css'
import { BackToBot } from '../../BackToBot'

import { EndConversationModal } from '../../EndConversationModal'
import { FeedbackModal } from '../../FeedbackModal'
import { useFeedbackModalContext } from '../../FeedbackModal/context'
import { useEndConversationModalContext } from '../../EndConversationModal/context'

const Container = props => {
  const {
    botId,
    device,
    isMobile,
    settings,
    persistentMenu,
    parentURL,
    messages,
    textDisabled,
    toggleWidget,
    resizeWidget,
    startData,
    operatorName,
    filesForUpload,
    firstUnreadMessageId,
    updateMessages,
    isFullScreenWidget,
    resetAttachmentFiles,
    handleHiddenWidget,
    setFirstUnreadMessageId,
  } = props

  const isRtl =
    messages && messages.length && messages[messages.length - 1].isRtl
  const { isOpenEndConversationModal, setIsOpenEndConversationModal } =
    useEndConversationModalContext()
  const { isOpenFeedbackModal, setIsOpenFeedbackModal } =
    useFeedbackModalContext()

  useEffect(() => {
    return () => {
      setFirstUnreadMessageId(null)
      setIsOpenEndConversationModal(false)
      setIsOpenFeedbackModal(false)
    }
  }, [])

  const containerStyle = useMemo(() => {
    return (
      device &&
      styleByScreenSize(
        isFullScreenWidget,
        device.width,
        device.height,
        isMobile,
      )
    )
  }, [isFullScreenWidget, device, isMobile])

  return (
    <WebSocketsSharedConsumer>
      {value => (
        <div className={classes.container} style={containerStyle}>
          {settings && (
            <Header
              isMobile={isMobile}
              resizeWidget={resizeWidget}
              toggleWidget={toggleWidget}
              widgetLogo={settings.logo}
              header={settings.widgetName}
              widgetColor={settings.color}
              isFullScreenWidget={isFullScreenWidget}
              handleHiddenWidget={handleHiddenWidget}
            />
          )}
          {operatorName && (
            <BackToBot
              isRtl={isRtl}
              chatId={value.chatId}
              postMessage={value.postMessage}
              startData={startData}
              operatorName={operatorName}
              widgetColor={settings.color}
            />
          )}
          {value && (
            <Chat
              device={device}
              isMobile={isMobile}
              messages={messages}
              settings={settings}
              persistentMenu={persistentMenu}
              parentURL={parentURL}
              showTyping={value.showTyping}
              startData={value.startData}
              connected={value.connected}
              postMessage={value.postMessage}
              textDisabled={textDisabled}
              filesForUpload={filesForUpload}
              updateMessages={updateMessages}
              firstUnreadMessageId={firstUnreadMessageId}
              chatId={value.chatId}
              botId={value.botId}
              updateTyping={value.updateTyping}
              getConversationId={value.getConversationId}
              isFullScreenWidget={isFullScreenWidget}
              resetAttachmentFiles={resetAttachmentFiles}
              initializeConversation={value.initializeConversation}
              getMoreChatHistory={value.getMoreChatHistory}
            />
          )}
          {isOpenEndConversationModal && (
            <EndConversationModal
              botId={botId}
              language={value.language}
              chatId={value.chatId}
              toggleWidget={toggleWidget}
            />
          )}
          {isOpenFeedbackModal && (
            <FeedbackModal
              botId={botId}
              chatId={value.chatId}
              toggleWidget={toggleWidget}
            />
          )}
        </div>
      )}
    </WebSocketsSharedConsumer>
  )
}

export default Container
